import { clone } from "../../utils";
import moment from "moment";

export function castAffairFromDb(affair){
    let clonedAffair = clone(affair);
    clonedAffair.date_start = moment(clonedAffair.date_start);
    clonedAffair.date_end = moment(clonedAffair.date_end);
    clonedAffair.date_signed = moment(clonedAffair.date_signed);
    return clonedAffair;
}

export function adaptAffairForMyOpen(affair) {
    let newAffair = clone(affair);
    newAffair.date_start = moment(newAffair.date_start);
    newAffair.date_end = moment(newAffair.date_end);
    newAffair.date_signed = moment(newAffair.date_signed);
    return newAffair;
}

export function adaptAffairForOpenERP(affair) {
    affair = clone(affair);
    
    return affair;
}
